<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          商品类型
        </div>
        <el-select
          v-model="searchForm.productType"
          placeholder="请选择商品类型"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in productTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          机构
        </div>
        <el-select
          v-model="searchForm.buyAgencyId"
          placeholder="请选择机构"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="r">
        <el-select
          v-model="orderSearchType"
          class="input-select"
          placeholder="请选择状态"
          filterable
          clearable
          @change="clearSearchValue"
        >
          <el-option
            v-for="item in orderSearchList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="searchForm[orderSearchType]"
          :placeholder="placeholder[orderSearchType]"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="openDialog"
        >
          使用抵用券
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
    />
    <coupon-info
      :dialog-visible.sync="dialogVisible"
      @getCouponInfo="getCouponInfo"
    />
  </div>
</template>

<script>
import { } from 'vuex';
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import couponInfo from '@/components/common/couponInfo.vue';
import types, { productTypeList, orderSearchList } from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
    couponInfo,
  },
  data() {
    return {
      productTypeList,
      orderSearchList,
      dialogVisible: false,
      agencyList: [],
      tabelData: {},
      orderSearchType: 'productName',
      placeholder: {
        productName: '请输入商品名称',
        buyUserRealName: '请输入购买人真实姓名',
        couponNumber: '请输入券号(精准搜索)',
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        buyAgencyId: '',
        productName: '',
        productType: '',
        buyUserRealName: '',
        couponNumber: '',
        sortType: null,
      },
      tableColumn: [
        {
          key: 'buyUserRealName',
          label: '购买人姓名',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'productType',
          label: '商品类型',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => productTypeList.filter((item) => item.value === key),
        },
        {
          key: 'pointsPrice',
          label: '消费积分',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'buyAgencyName',
          label: '机构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'productName',
          label: '商品名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isUse',
          label: '是否使用',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.PRODUCT_ISUSE]: '使用', [types.PRODUCT_NOUSE]: '未使用', successKey: types.PRODUCT_ISUSE },
          render: () => 'status',
        },
        {
          key: 'useTime',
          label: '使用时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'createTime',
          label: '购买时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
        // {
        //   key: 'control',
        //   label: '操作',
        //   width: '60px',
        //   dataType: 'component',
        //   renderProps: [
        //     {
        //       text: '使用', renderKey: null, type: 'primary', eventIndex: 0, disableKey: types.PRODUCT_ISUSE,
        //     },
        //   ],
        //   render: () => 'buttons',
        // },
      ],
    };
  },
  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.buyUserRealName = '';
      this.searchForm.productName = '';
      this.searchForm.couponNumber = '';
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.points.getPageOrder(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 确认使用辅导员抵用券
    confirmDialog(item) {
      this.$confirm('确定使用该辅导员抵用券？', '使用该辅导员抵用券', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { couponNumber } = item;
        const data = await axClient.points.useCounselorCoupon(
          {
            couponNumber,
          },
        );
        if (data) {
          this.$message.success('使用成功');
          this.getList();
        }
      });
    },
    // table 传递过来的按钮点击
    openDialog() {
      this.dialogVisible = true;
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // selectList
    async selectList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.agencyList = await axClient.common.listNameByPointsProductOrder();
      this.agencyList = [all, ...this.agencyList];
    },
    // 查询辅导员抵用券
    getCouponInfo(item) {
      this.confirmDialog(item);
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
